import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { AddressFragmentDoc } from '../../../lib/contexts/LocationDetailContext/LocationDetailContext.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LocationDialog_LocationQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type LocationDialog_LocationQuery = { __typename?: 'Query', Location?: { __typename?: 'Location', id: number, name: string, address?: { __typename?: 'Address', id: string, lineOne: string, lineTwo?: string | null, city: string, usState?: USState | null, country: string, postalCode: string, lat?: number | null, lng?: number | null } | null, locationGroupMemberships: Array<{ __typename?: 'LocationGroupMembership', id: string, locationGroup: { __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType } }> } | null };

export type CreateLocationMutationVariables = Types.Exact<{
  input: Types.CreateLocationInput;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation: { __typename?: 'LocationMutationResult', success: boolean, location?: { __typename?: 'Location', id: number, name: string, address?: { __typename?: 'Address', id: string, lineOne: string, lineTwo?: string | null, city: string, usState?: USState | null, country: string, postalCode: string, lat?: number | null, lng?: number | null } | null } | null } };

export type UpdateLocationMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  input: Types.UpdateLocationInput;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateLocation: { __typename?: 'LocationMutationResult', success: boolean, location?: { __typename?: 'Location', id: number, name: string, address?: { __typename?: 'Address', id: string, lineOne: string, lineTwo?: string | null, city: string, usState?: USState | null, country: string, postalCode: string, lat?: number | null, lng?: number | null } | null } | null } };

export type LocationDialog_LocationWithAddressFragment = { __typename?: 'Location', id: number, name: string, address?: { __typename?: 'Address', id: string, lineOne: string, lineTwo?: string | null, city: string, usState?: USState | null, country: string, postalCode: string, lat?: number | null, lng?: number | null } | null };

export type LocationDialog_LocationFragment = { __typename?: 'Location', id: number, name: string, address?: { __typename?: 'Address', id: string, lineOne: string, lineTwo?: string | null, city: string, usState?: USState | null, country: string, postalCode: string, lat?: number | null, lng?: number | null } | null, locationGroupMemberships: Array<{ __typename?: 'LocationGroupMembership', id: string, locationGroup: { __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType } }> };

export type LocationDialog_LocationGroupQueryVariables = Types.Exact<{
  type: Types.LocationGroupType;
}>;


export type LocationDialog_LocationGroupQuery = { __typename?: 'Query', LocationGroups: { __typename?: 'LocationGroups', objects: Array<{ __typename?: 'LocationGroup', id: string, name: string }> } };

export const LocationDialog_LocationWithAddressFragmentDoc = gql`
    fragment LocationDialog_LocationWithAddress on Location {
  id
  name
  address {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export const LocationDialog_LocationFragmentDoc = gql`
    fragment LocationDialog_Location on Location {
  id
  name
  address {
    ...Address
  }
  locationGroupMemberships {
    id
    locationGroup {
      id
      name
      type
    }
  }
}
    ${AddressFragmentDoc}`;
export const LocationDialog_LocationDocument = gql`
    query locationDialog_Location($id: Int!) {
  Location(id: $id) {
    ...LocationDialog_Location
  }
}
    ${LocationDialog_LocationFragmentDoc}`;

/**
 * __useLocationDialog_LocationQuery__
 *
 * To run a query within a React component, call `useLocationDialog_LocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationDialog_LocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationDialog_LocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationDialog_LocationQuery(baseOptions: Apollo.QueryHookOptions<LocationDialog_LocationQuery, LocationDialog_LocationQueryVariables> & ({ variables: LocationDialog_LocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationDialog_LocationQuery, LocationDialog_LocationQueryVariables>(LocationDialog_LocationDocument, options);
      }
export function useLocationDialog_LocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationDialog_LocationQuery, LocationDialog_LocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationDialog_LocationQuery, LocationDialog_LocationQueryVariables>(LocationDialog_LocationDocument, options);
        }
export type LocationDialog_LocationQueryHookResult = ReturnType<typeof useLocationDialog_LocationQuery>;
export type LocationDialog_LocationLazyQueryHookResult = ReturnType<typeof useLocationDialog_LocationLazyQuery>;
export type LocationDialog_LocationQueryResult = Apollo.QueryResult<LocationDialog_LocationQuery, LocationDialog_LocationQueryVariables>;
export const CreateLocationDocument = gql`
    mutation createLocation($input: CreateLocationInput!) {
  createLocation(input: $input) {
    success
    location {
      ...LocationDialog_LocationWithAddress
    }
  }
}
    ${LocationDialog_LocationWithAddressFragmentDoc}`;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation updateLocation($id: Int!, $input: UpdateLocationInput!) {
  updateLocation(id: $id, input: $input) {
    success
    location {
      ...LocationDialog_LocationWithAddress
    }
  }
}
    ${LocationDialog_LocationWithAddressFragmentDoc}`;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const LocationDialog_LocationGroupDocument = gql`
    query LocationDialog_LocationGroup($type: LocationGroupType!) {
  LocationGroups(input: {types: [$type]}) {
    objects {
      id
      name
    }
  }
}
    `;

/**
 * __useLocationDialog_LocationGroupQuery__
 *
 * To run a query within a React component, call `useLocationDialog_LocationGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationDialog_LocationGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationDialog_LocationGroupQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLocationDialog_LocationGroupQuery(baseOptions: Apollo.QueryHookOptions<LocationDialog_LocationGroupQuery, LocationDialog_LocationGroupQueryVariables> & ({ variables: LocationDialog_LocationGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationDialog_LocationGroupQuery, LocationDialog_LocationGroupQueryVariables>(LocationDialog_LocationGroupDocument, options);
      }
export function useLocationDialog_LocationGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationDialog_LocationGroupQuery, LocationDialog_LocationGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationDialog_LocationGroupQuery, LocationDialog_LocationGroupQueryVariables>(LocationDialog_LocationGroupDocument, options);
        }
export type LocationDialog_LocationGroupQueryHookResult = ReturnType<typeof useLocationDialog_LocationGroupQuery>;
export type LocationDialog_LocationGroupLazyQueryHookResult = ReturnType<typeof useLocationDialog_LocationGroupLazyQuery>;
export type LocationDialog_LocationGroupQueryResult = Apollo.QueryResult<LocationDialog_LocationGroupQuery, LocationDialog_LocationGroupQueryVariables>;